import React from 'react';
import { useChat } from '../contexts/ChatContext';
import ChatLayout from '../components/Layout/ChatLayout';
import Sidebar from '../components/Sidebar/Sidebar';
import ChatArea from '../components/Chat/ChatArea';
import WelcomeContent from '../components/Chat/WelcomeContent';

const ChatPage = () => {
  const { 
    sessions, 
    currentSessionId, 
    messages, 
    loading, 
    error,
    setCurrentSessionId, 
    sendMessage, 
    deleteSession, 
    clearAllSessions,
    handleExampleClick
  } = useChat();

  // Determine if we should show the welcome screen content
  const showWelcomeContent = !currentSessionId && (!messages || messages.length === 0);

  // Handle new chat click - make sure to clear session ID
  const handleNewChat = () => {
    // Setting currentSessionId to null will trigger the useEffect in ChatContext
    // that clears the messages array
    setCurrentSessionId(null);
  };

  return (
    <ChatLayout>
      <Sidebar 
        sessions={sessions}
        currentSessionId={currentSessionId}
        onNewChat={handleNewChat}
        onSelectSession={setCurrentSessionId}
        onDeleteSession={deleteSession}
        onClearAll={clearAllSessions}
      />
      
      {showWelcomeContent ? (
        <WelcomeContent 
          onExampleClick={handleExampleClick} 
          onSendMessage={sendMessage}
          loading={loading}
        />
      ) : (
        <ChatArea 
          currentSessionId={currentSessionId}
          messages={messages}
          loading={loading}
          error={error}
          onSendMessage={sendMessage}
          onExampleClick={handleExampleClick}
        />
      )}
    </ChatLayout>
  );
};

export default ChatPage; 